module.exports = __webpack_public_path__ + "media/fonts/formular-black-webfont-210aafd87a5eab2e4d54da27c65b171a.woff";